import { api } from '../api';

// Get or create message thread
export const getMessageThread = async (threadId) => {
  const result = await api.getMessageThread(threadId);
  if (result.error) {
    return null;
  }
  return result.data;
};

// Get messages for a thread
export const getThreadMessages = async (threadId) => {
  const result = await api.getThreadMessages(threadId);
  if (result.error) {
    throw new Error(result.error);
  }
  return result.data;
};

// Send message
export const sendMessage = async (threadId, messageData) => {
  const result = await api.sendMessage(threadId, messageData);
  if (result.error) {
    throw new Error(result.error);
  }
  return result.data.id;
};

// Get user's message threads
export const getUserThreads = async (userId) => {
  const result = await api.getUserThreads(userId);
  if (result.error) {
    throw new Error(result.error);
  }
  return result.data;
};

// Helper to create thread ID from booking
export const createThreadIdFromBooking = (bookingId) => {
  return `booking_${bookingId}`;
};

// Create or get message thread for a booking
export const getOrCreateBookingThread = async (bookingId, participants) => {
  const result = await api.getOrCreateBookingThread(bookingId, participants);
  if (result.error) {
    throw new Error(result.error);
  }
  return result.data;
};

